/*
 *
 * Home actions
 *
 */

import {
  GET_USER_MANDU_FAILED,
  GET_USER_MANDU_SUCCESS,
  GET_USER_MANDU_WATCHER,
  GET_USER_CREATE_MANDU_FAILED,
  GET_USER_CREATE_MANDU_SUCCESS,
  GET_USER_CREATE_MANDU_WATCHER,
  DELETE_COMPANY_USER_ACCESS_MANDU_FAILED,
  DELETE_COMPANY_USER_ACCESS_MANDU_SUCCESS,
  DELETE_COMPANY_USER_ACCESS_MANDU_WATCHER,
  SAVE_COMPANY_USER_ACCESS_MANDU_FAILED,
  SAVE_COMPANY_USER_ACCESS_MANDU_SUCCESS,
  SAVE_COMPANY_USER_ACCESS_MANDU_WATCHER,
  USER_DELETE_FAILED,
  USER_DELETE_SUCCESS,
  USER_DELETE_WATCHER,
  RECOVERY_PASSWORD_WATCHER,
  RECOVERY_PASSWORD_FAILED,
  RECOVERY_PASSWORD_SUCCESS,
  USER_SAVE_WATCHER,
  USER_SAVE_SUCCESS,
  USER_SAVE_FAILED,
  USER_CHANGE_ROLE_WATCHER,
  DELETE_USER_WATCHER,
  DELETE_USER_SUCCESS,
  DELETE_USER_FAILED,
  GET_OPTIONS_WATCHER,
  GET_OPTIONS_SUCCESS,
} from "./constants"

export function getUsersManduWatcher(payload) {
  return {
    type: GET_USER_MANDU_WATCHER,
    payload,
  }
}

export function getUsersManduSuccess(payload) {
  return {
    type: GET_USER_MANDU_SUCCESS,
    payload,
  }
}

export function getUsersManduFailed() {
  return { type: GET_USER_MANDU_FAILED }
}

export function getUserCreateManduWatcher(payload) {
  return {
    type: GET_USER_CREATE_MANDU_WATCHER,
    payload,
  }
}

export function getUserCreateManduSuccess(payload) {
  return {
    type: GET_USER_CREATE_MANDU_SUCCESS,
    payload,
  }
}

export function getUserCreateManduFailed() {
  return { type: GET_USER_CREATE_MANDU_FAILED }
}

export function saveCompanyUserAccessManduWatcher(payload) {
  return {
    type: SAVE_COMPANY_USER_ACCESS_MANDU_WATCHER,
    payload,
  }
}

export function saveCompanyUserAccessManduSuccess(payload) {
  return {
    type: SAVE_COMPANY_USER_ACCESS_MANDU_SUCCESS,
    payload,
  }
}

export function saveCompanyUserAccessManduFailed() {
  return { type: SAVE_COMPANY_USER_ACCESS_MANDU_FAILED }
}

export function deleteCompaniesUserAccessManduWatcher(payload) {
  return {
    type: DELETE_COMPANY_USER_ACCESS_MANDU_WATCHER,
    payload,
  }
}

export function deleteCompaniesUserAccessManduSuccess(payload) {
  return {
    type: DELETE_COMPANY_USER_ACCESS_MANDU_SUCCESS,
    payload,
  }
}

export function deleteCompaniesUserAccessManduFailed() {
  return { type: DELETE_COMPANY_USER_ACCESS_MANDU_FAILED }
}

// user delete
export function userDeleteWatcher(payload) {
  return {
    type: USER_DELETE_WATCHER,
    payload,
  }
}

export function userDeleteSuccess(payload) {
  return {
    type: USER_DELETE_SUCCESS,
    payload,
  }
}

export function userDeleteFailed() {
  return { type: USER_DELETE_FAILED }
}
// user recovery pass
export function recoveryPasswordWatcher(payload) {
  return {
    type: RECOVERY_PASSWORD_WATCHER,
    payload,
  }
}

export function recoveryPasswordSuccess(payload) {
  return {
    type: RECOVERY_PASSWORD_SUCCESS,
    payload,
  }
}

export function recoveryPasswordFailed() {
  return { type: RECOVERY_PASSWORD_FAILED }
}
// user save
export function saveUserWatcher(payload) {
  return {
    type: USER_SAVE_WATCHER,
    payload,
  }
}

export function saveUserSuccess(payload) {
  return {
    type: USER_SAVE_SUCCESS,
    payload,
  }
}

export function saveUserFailed() {
  return { type: USER_SAVE_FAILED }
}

export function deleteUserWatcher(payload) {
  return {
    type: DELETE_USER_WATCHER,
    payload,
  }
}

export function deleteUserSuccess(payload) {
  return {
    type: DELETE_USER_SUCCESS,
    payload,
  }
}

export function deleteUserFailed(payload) {
  return {
    type: DELETE_USER_FAILED,
    payload,
  }
}

export function getOptionsWatcher(payload) {
  return {
    type: GET_OPTIONS_WATCHER,
    payload,
  }
}

export function getOptionsSuccess(payload) {
  return {
    type: GET_OPTIONS_SUCCESS,
    payload,
  }
}

export function userChangeRoleWatcher(payload) {
  return {
    type: USER_CHANGE_ROLE_WATCHER,
    payload,
  }
}
